import { render, staticRenderFns } from "./AddToGroupTable.vue?vue&type=template&id=9bfffcf6&scoped=true"
import script from "./AddToGroupTable.vue?vue&type=script&lang=js"
export * from "./AddToGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfffcf6",
  null
  
)

export default component.exports